import { render, staticRenderFns } from "./employeesWithdrawal.vue?vue&type=template&id=5966d5fa"
import script from "./employeesWithdrawal.vue?vue&type=script&lang=js"
export * from "./employeesWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports